import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {keyDisplayName} from '../../../../util/runs';
import {
  useMediaSliderKeyDisplay,
  useMediaSliderSyncDisplay,
  useShouldShowMediaSliderSyncResetAtLevel,
} from '../hooks';
import {SettingTitle} from './common/SettingTitle';
import {useMediaSettingsContext} from './contexts/MediaSettingsContextProvider';

export const SliderSync = () => {
  const {updateConfig, unsetConfigField, settingsLevel} =
    useMediaSettingsContext();
  const sliderSync = useMediaSliderSyncDisplay(settingsLevel);
  const isSetAtLevel = useShouldShowMediaSliderSyncResetAtLevel(settingsLevel);
  const sliderSyncKey = useMediaSliderKeyDisplay(settingsLevel);
  const sliderSyncKeyDisplayName = keyDisplayName({
    section: 'summary',
    name: sliderSyncKey,
  });
  const [isChecked, setIsChecked] = useState(sliderSync);
  return (
    <div className="flex justify-between">
      <SettingTitle
        title={`Sync slider by key (${sliderSyncKeyDisplayName})`}
        configField="sliderSync"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('sliderSync')}
        description={`Adjusting one slider updates others in this ${settingsLevel} using the same key (${sliderSyncKeyDisplayName})`}
      />
      <Switch.Root
        aria-label="Toggle slider sync"
        data-test="slider-sync-switch"
        checked={isChecked}
        onCheckedChange={newIsChecked => {
          setIsChecked(newIsChecked);
          // Allow the switch to animate before updating the config so that it's more of a smooth
          // transition before the component re-mounts
          setTimeout(() => {
            updateConfig({sliderSync: newIsChecked});
          }, 100);
        }}>
        <Switch.Thumb checked={isChecked} />
      </Switch.Root>
    </div>
  );
};
